export default {
  email_password_required: 'Email and password are required',
  my_projects: 'My Projects',
  see_details: 'See full project',
  see_results: 'See results',
  trials: 'Trials',

  new_project: 'New Project',
  new_project_default_name: 'New project name',
  create_project: 'Create Project',
  create_project_description: 'New project:',
  no_projects: 'There are no projects.',
  status_draft: 'draft',
  status_submitted: 'validating',
  status_deploying: 'validating',
  status_ongoing: 'ongoing',
  status_closed: 'closed',
  status_ready: 'ready',
  status_running: 'running',
  status_paused: 'paused',
  status_finished: 'finished',
  status_aborted: 'aborted',
  status_cancelled: 'cancelled',
  status_archived: 'archived',
  status_failed: 'failed',
  Close: 'Close',
  
  sort_by: 'Sort by',
  show_projects: 'Show',
  explore_details: 'Compare Results',
  view_by: 'View by',
  selected_group: 'Selected group',
  x_axis: 'X-axis',
  y_axis: 'Y-axis',
  compare_with: 'Compare with',
  color_intensity: 'Color intensity',
  point_size: 'Size',
  color_scale_attr: 'Color',
  create_group_from_sel: 'Create group from selection',
  trials_scatter_mode: 'scatter',
  trials_heatmap_mode: 'heatmap',
  trials_list_mode: 'list',
  brush_notice_rect: 'Drag to select in a rectangular area',
  brush_notice_poly: 'Draw a polygon to select (right-click to finish)',
  reset_zoom: 'Reset view',
  
  config_population: 'Population',
  config_comorbidities: 'Comorbidities',
  config_disease: 'Disease',
  config_treatment: 'Treatment',
  view_results: 'View results',
  view_results_for_this_case: 'View results for this case',
  
  new_trial: 'New trial',
  new_trial_default_name: 'New trial name',
  new_trial_duplicate_default_name: 'New trial name',
  create_trial: 'Create trial',
  create_trial_description: 'New trial',
  create_trial_duplicate: 'Copy trial',
  create_trial_duplicate_default_name: 'New trial name',
  create_trial_duplicate_description: 'Copy trial configuration',
  copy_of: 'Copy of',
  output_analysis: 'Output analysis',
  trial_params: 'Running configuration',
  multiple_trials: 'Multiple trials',
  new_trial_placeholder: 'New trial name',
  no_trials: 'There are no trials in this project.',
  no_trials_selection: 'There are no trials with this filter selection.',
  saved: 'Saved',
  saving: 'Saving...',
  single_trial: 'Single trial',
  out_of_range: 'Out of range',

  ready_to_run: 'Run config',
  save_config: 'Save config',

  parameters: 'General characteristics',
  // comorbidityList: 'Pathologies',
  populations: 'Populations',
  population_params: 'Populations',
  diseases: 'Diseases',
  treatments: 'Treatments',
  resultScalars: 'Result scalars',
  number_of_subjects: 'Number of subjects',
  histogram: 'Histogram',
  ecg: 'ECG',
  select_one_ecg: 'Select at least 1 subject to visualize the ECGs',
  nothing_to_show: 'Nothing to show',
  slices: 'Slices',

  subject: 'Subject',
  
  edit: 'Edit',
  save: 'Save',
  run: 'Run',
  remove: 'Remove',
  add: 'Add',
  add_filter: 'Add filter',
  edit_filter: 'Edit filter',
  OK: 'OK',
  ok: 'Ok',
  processing: 'Processing...',

  import_from: 'Import from',
  import_config_from: 'Import %config% configuration',
  
  run_configuration: 'Run configuration',
  duration: 'duration',
  modelling: 'modelling',
  confirm: 'Confirm',
  submit: 'Simulate',
  validating: 'Validating...',
  run: 'Run',
  tokens: 'Tokens',
  compute_tokens: 'Compute Tokens',
  cost: 'Cost',

  segments_with_values: 'Segments with values in this project',
  statistics: 'Statistics',
  download_report: 'Download Report',
  export: 'Export',
  generate: 'Generate',
  export_csv: 'Export CSV',
}